Step
{{ currentStepMetadata.currentStepNum }}
<span *ngIf="!hideTotalCount">
    of
    {{ currentStepMetadata.numberOfSteps }}:
</span>
{{ currentStepMetadata.currentStep.title }}